import { Col, Form, Row} from "react-bootstrap";
import React from "react";

export function AddressDisplay({address}){

    return (
        <>
            <div>{address.street} {address.building_num}/{address.local_num} {address.postal_code} {address.city}</div>
        </>
    )
}

export function addressAsString({street, building_num, local_num, postal_code, city}){
    return `${street !== null ? street : ""} ${building_num !== null ? building_num: ""} ${local_num !== null ? "/"+local_num:""} ${postal_code !== null ?postal_code:""} ${city !==null ? city:""}`;
}

export default function AddressForm(props){
    const formData = props.default ? props.default : { address_name: '', street: '', building_num:'', local_num:'',postal_code:'',city:'', country:'Polska' };


    const handleChange = e => {
        const newFOrmData = { ...formData, [e.target.name]: e.target.value }

        if (props.onChange) {
            props.onChange({address:newFOrmData})
        }
    }

    return (
        <Row className={"pb-3"}>
                <Col lg={4} md={8}>
                    <Form.Group size="lg" controlId="street">
                        <Form.Label>Ulica</Form.Label>
                        <Form.Control
                            type="text"
                            name="street"
                            value={formData.street}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col lg={1} md={2}>
                    <Form.Group size="lg" controlId="building_num">
                        <Form.Label>Nr </Form.Label>
                        <Form.Control
                            type="text"
                            name="building_num"
                            value={formData.building_num}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col lg={1} md={2}>
                    <Form.Group size="lg" controlId="local_num">
                        <Form.Label>lokal</Form.Label>
                        <Form.Control
                            type="text"
                            name="local_num"
                            value={formData.local_num}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col lg={2} md={4}>
                    <Form.Group size="lg" controlId="postal_code">
                        <Form.Label>Kod pocztowy</Form.Label>
                        <Form.Control
                            type="text"
                            name="postal_code"
                            value={formData.postal_code}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col lg={2} md={4}>
                    <Form.Group size="lg" controlId="city">
                        <Form.Label>Miasto</Form.Label>
                        <Form.Control
                            type="text"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col lg={2} md={4}>
                    <Form.Group size="lg" controlId="country">
                        <Form.Label>Kraj</Form.Label>
                        <Form.Control
                            type="text"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
        </Row>
    )
}